module.exports = "//static.hsappstatic.net/salesImages/static-1.403/integrations/webhook_subscriptions_empty.png"